import { AIButtonContainedGrey as AIButtonContainedGreyButton } from '../../AIButton'
import { BUTTON_ICON_SIZES, BUTTON_SIZES } from '../Buttons'
import { Container } from '../Container'

import EditIcon from '../../../icons/edit.svg'
import PlusIcon from '../../../icons/plus.svg'

export function AIButtonContainedGrey() {
  return (
    <>
      <Container label='AI Button, contained grey, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedGreyButton height={size} key={size} text='Button' />
        ))}
      </Container>
      <Container label='AI Button, contained grey, disabled, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            disabled
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained grey, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            isLoading
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained grey, with pre icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained grey, with pre icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained grey, with post icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            afterIconProps={{ Icon: EditIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained grey, with post icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            isLoading
            afterIconProps={{ Icon: EditIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained grey, with skeleton, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            isSkeleton
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained grey, icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, contained grey, icon, disabled, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            disabled
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, contained grey, icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, contained grey, icon, with skeleton, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            isSkeleton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, contained grey, circle icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            isCircle
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, contained grey, circle icon, disabled, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            disabled
            isCircle
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, contained grey, circle icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            isCircle
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, contained grey, circle icon, with skeleton, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedGreyButton
            isCircle
            isSkeleton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
